<template>
    <v-row no-gutters class="employment-doc-view">
        <v-col class="employment-doc-view__side" cols="12" lg="auto">
            <employment-doc-side v-model="index" v-bind="{ pages }" v-on="{ input: scroll }" />
        </v-col>
        <v-col cols="12" lg="auto" class="d-none d-lg-block">
            <v-divider vertical />
        </v-col>
        <v-col class="employment-doc-view__body" cols="12" lg="auto">
            <employment-doc-body
                v-model="items"
                v-bind="{
                    pages,
                    index,
                    mode,
                }"
                v-on="{
                    input: emit,
                    setIndex,
                }"
                ref="employment-doc-body"
            />
            <!-- <employment-doc-zoom
                class="employment-doc-view__zoom"
                v-bind="{
                    mode,
                    hideZoom,
                }"
            /> -->
            <employment-doc-down
                class="employment-doc-view__down"
                v-bind="{
                    mode,
                    loading,
                }"
                v-on="{
                    down,
                }"
            />
        </v-col>
    </v-row>
</template>

<script>
import download from "downloadjs";
import { downEmploymentContract, initEmploymentContract, initEmploymentField } from "@/assets/variables";

import EmploymentDocBody from "./employment-doc-body.vue";
import EmploymentDocSide from "./employment-doc-side.vue";
import EmploymentDocZoom from "./employment-doc-zoom.vue";
import EmploymentDocDown from "./employment-doc-down.vue";

export default {
    components: {
        EmploymentDocBody,
        EmploymentDocSide,
        EmploymentDocZoom,
        EmploymentDocDown,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        contract: { type: Object, default: initEmploymentContract },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentField[]>} */
        value: { type: Array, default: () => [] },
        pages: { type: Array, default: () => [] },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        hideZoom: { type: Boolean, default: false },
    },
    data: () => ({
        items: [],
        index: 0,
        loading: false,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.items = [...this.value].map(initEmploymentField);
        },
        emit() {
            this.$emit("input", this.items);
        },
        async down() {
            if (this.loading) return;
            else this.loading = true;
            try {
                let file = await downEmploymentContract(this.contract);
                download(file, file.name);
            } finally {
                this.loading = false;
            }
        },
        setIndex(index) {
            this.index = index;
        },
        scroll(index) {
            this.$refs["employment-doc-body"].scroll(index);
        },
    },
};
</script>

<style lang="scss" scoped>
.employment-doc-view {
    position: relative;

    &,
    & > *:not(&__zoom) {
        height: 100%;
    }

    &__body {
        width: 100%;
    }
    &__down {
        position: absolute;
        bottom: 12px;
        right: 12px;
    }
    &__side {
        display: none;
    }
    &__zoom {
        position: absolute;
        top: 12px;
        right: 12px;
    }
}
@media (min-width: 1024px) {
    .employment-doc-view {
        &__body {
            width: calc(100% - 1px - 120px);
        }
        &__side {
            display: block;
            max-width: 120px;
        }
    }
}
</style>
